import { useTheme } from '@mui/material';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import { useMediaQuery } from '@mui/system';
import RouterLink from 'components/RouterLink/RouterLink';
import { useBreadcrumbs } from 'hooks/useBreadcrumbs';

export default function AppbarBreadcrumbs() {
  const breadcrumbs = useBreadcrumbs();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));

  const maxItems = !isMobile && !isSmallScreen ? undefined : 1;
  return (
    <Breadcrumbs
      aria-label="breadcrumb"
      maxItems={maxItems}
      itemsBeforeCollapse={0}
      sx={{
        fontWeight: 'bold',
        color: theme => theme.palette.text.primary,
        '& .MuiBreadcrumbs-separator': {
          fontSize: '10px',
        },
      }}
    >
      {breadcrumbs.map(({ label, url }) => {
        return (
          <RouterLink
            to={url}
            key={`appbar-breadcrumb-${url}`}
            sx={{
              fontSize: '14px',
            }}
          >
            {label}
          </RouterLink>
        );
      })}
    </Breadcrumbs>
  );
}
